enum DynamicFormFieldType {
    telephone = 'tel',
    dropdown = 'dropdown',
    number = 'number',
    password = 'password',
    checkbox = 'checkbox',
    multiline = 'multiline',
    date = 'date',
    radio = 'radio',
    text = 'text',
}

export default DynamicFormFieldType;
